import { useState } from "react";
import { TRIAL } from "../../constants/testIds";
import { TrialBlockModal } from "./TrialBlockModal";

// UX-TRIAL §5 "a small persistent, calm badge — NOT styled like the Emulator's hazard flag" —
// reuses the standard dot+pill status-token language (`.status-pill.trial`, already defined in
// tokens.css for UX-CP-01's gym-lifecycle status system) rather than inventing a new visual
// treatment. `days_remaining`/`trial_ends_at` come straight from `GET /me`'s `trial_status`
// (no separate poll). Day number is derived (14 - days_remaining) since the backend only
// tracks the expiry, not a separate "day N" counter — documented approximation, off by at most
// one due to floor()-based day math on `days_remaining`.
export function TrialStatusBadge({ trialStatus }) {
  const [open, setOpen] = useState(false);
  if (!trialStatus?.is_trial) return null;
  const dayNumber = Math.min(14, Math.max(1, 14 - (trialStatus.days_remaining ?? 13)));
  const members = trialStatus.caps?.members || { used: 0, limit: 5 };

  return (
    <>
      <button
        type="button"
        data-testid={TRIAL.statusBadge}
        onClick={() => setOpen(true)}
        className="status-pill trial scarlet-focusable shrink-0"
      >
        <span className="dot" />
        Trial · Day {dayNumber} of 14 · {members.used}/{members.limit} members
      </button>
      <TrialBlockModal
        open={open}
        onOpenChange={setOpen}
        message="Upgrade to a paid plan to remove every trial limit and unlock all features."
      />
    </>
  );
}
